<template>
  <v-card :max-width="maxWidth" max-height="400px">
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step step="1">
          <small>{{ mode }}</small>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2">
          <small>{{ $t("holidayGroups.stepperHeaderStep2") }}</small>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3">
          <small>{{ $t("holidayGroups.stepperHeaderStep3") }}</small>
        </v-stepper-step>
      </v-stepper-header>
    </v-stepper>
    <v-form
      @submit.prevent="submitForm"
      ref="form"
      v-model="valid"
      class="form-container pa-4 pt-5"
    >
      <v-alert
        v-if="error"
        color="red"
        elevation="5"
        outlined
        text
        type="error"
        align="center"
        class="mx-1 mb-5"
      >
        {{ alertValidate }}
      </v-alert>

      <template v-if="step === 1">
        <div
          v-for="(input, index) in inputsForm"
          :key="'input_' + index + input.name"
        >
          <v-text-field
            :name="input.name"
            v-model="input.data"
            :label="input.label"
            :rules="input.rules"
            outlined
            dense
          />
        </div>
        <div class="d-flex justify-space-between">
          <div>
            <v-btn class="bt-exit mr-2" @click="cancel">{{
              $tc("editRegistrations.cancel")
            }}</v-btn>
            <v-btn @click="nextStep" class="bt-next" :disabled="!valid">{{
              $tc("holidayGroups.next")
            }}</v-btn>
          </div>
          <v-btn @click="submitForm" :disabled="!valid" class="bt-acept">{{
            buttonText
          }}</v-btn>
        </div>
      </template>

      <template v-if="step === 2">
        <div class="mb-5 text-center" v-if="getCurrentYearVisible">
          <v-btn class="bt-primary primary" @click="openDialog">
            {{ $tc("holidays.getHolidays") }} {{ currentYear }}
          </v-btn>
        </div>
        <holidays-import-dialog
          :title="$tc('holidays.dialogTitle')"
          :visible="dialogVisible"
          :year="currentYear"
          @close="closeDialog"
          @showSnackbar="showSnackbar"
          :key="keyImportHolidays"
        ></holidays-import-dialog>
        <v-autocomplete
          :name="selects[0].name"
          :items="selects[0].items"
          :item-text="truncateText"
          :item-value="selects[0].itemsValue"
          v-model="selects[0].data"
          :label="selects[0].label"
          :rules="selects[0].rules"
          outlined
          solo
          clearable
          multiple
          small-chips
          dense
          :menu-props="{ auto: false, overflowY: true }"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index < 1">
              <span>{{ item.name }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text text-caption">
              (+ {{ selects[0].data.length - 1 }} )
            </span>
          </template>
        </v-autocomplete>
        <div class="d-flex justify-space-between">
          <v-btn class="bt-exit" @click="cancel">{{
            $tc("editRegistrations.cancel")
          }}</v-btn>
          <div>
            <v-btn @click="prevStep" class="bt-previous mr-2">{{
              $tc("holidayGroups.previous")
            }}</v-btn>
            <v-btn @click="nextStep" class="bt-next" :disabled="!valid">{{
              $tc("holidayGroups.next")
            }}</v-btn>
          </div>
          <v-btn @click="submitForm" :disabled="!valid" class="bt-acept">{{
            buttonText
          }}</v-btn>
        </div>
      </template>

      <template v-if="step === 3">
        <v-autocomplete
          :name="selects[1].name"
          :items="selects[1].items"
          :item-text="selects[1].itemsText"
          :item-value="selects[1].itemsValue"
          v-model="selects[1].data"
          :label="selects[1].label"
          :rules="selects[1].rules"
          outlined
          solo
          clearable
          multiple
          small-chips
          dense
          :menu-props="{ offsetY: true }"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index < 1">
              <span>{{ item.name }}</span>
            </v-chip>
            <span v-if="index === 1" class="grey--text text-caption">
              (+ {{ selects[1].data.length - 1 }} )
            </span>
          </template>
        </v-autocomplete>
        <div class="d-flex justify-space-between">
          <v-btn class="bt-exit" @click="cancel">{{
            $tc("editRegistrations.cancel")
          }}</v-btn>
          <div>
            <v-btn @click="prevStep" class="bt-previous">{{
              $tc("holidayGroups.previous")
            }}</v-btn>
          </div>
          <v-btn @click="submitForm" :disabled="!valid" class="bt-acept">{{
            buttonText
          }}</v-btn>
        </div>
      </template>
    </v-form>
  </v-card>
</template>

<script>
import DateWithCheck from "@/components/Complement/DateWithCheck.vue";
import Vue from "vue";
import holidays from "@/store/gruposDeFeriados/holidays";
import HolidaysImportDialog from "../../Feriados/Forms/HolidaysImportDialog.vue";

export default {
  components: { DateWithCheck, HolidaysImportDialog },
  props: {
    items: {
      type: Array,
    },
    maxWidth: String,
    mode: String,
    show: {
      type: Boolean,
      default: false,
    },
    showDate: Boolean,
    itemsSelect: Array,
  },
  data() {
    return {
      authorizeLiquidations: true,
      inputsForm: [],
      selects: [],
      valid: true,
      error: false,
      alertValidate: "",
      step: 1,
      tempData: {},
      disableNext: true,
      currentYear: null,
      dialogVisible: false,
      keyImportHolidays: 0,
    };
  },
  mounted() {
    this.inputsForm = Vue.observable(this.items);
    this.selects = Vue.observable(this.itemsSelect);
    this.getCurrentYear();
  },
  computed: {
    buttonText() {
      return this.mode === this.$tc("holidayGroups.addHolidayGroup")
        ? this.$tc("commons.add")
        : this.$tc("commons.accept");
    },
    getCurrentYearVisible() {
      return this.mode === this.$tc("holidayGroups.addHolidayGroup")
        ? true
        : false;
    },
  },
  methods: {
    truncateText(item) {
      const maxLength = 60;
      if (item.name.length > maxLength) {
        return item.name.substring(0, maxLength) + "...";
      }
      return item.name;
    },
    openDialog() {
      this.dialogVisible = true;
    },
    async closeDialog() {
      await holidays.dispatch("getHolidays");
      this.selects[0].items = holidays.state.holidays;
      this.dialogVisible = false;
    },
    submitForm(e) {
      this.saveTemporaryData();
      e.preventDefault();
      this.validation(this.$refs.form.$el);
    },

    handleSubmit(form) {
      const formData = new FormData(form);
      const itemsComplete = {};

      for (let [name, value] of formData) {
        if (Array.isArray(value)) {
          itemsComplete[name] = value;
        } else {
          itemsComplete[name] = value;
        }
      }

      for (let select of this.selects) {
        itemsComplete[select.name] = select.data;
      }

      const mergedData = { ...itemsComplete, ...this.getTemporaryData() };

      this.$refs.form.resetValidation();
      this.$emit("save", mergedData);
      this.step = 1;
    },
    cancel() {
      this.$refs.form.resetValidation();

      this.$emit("cancel", false);
      this.step = 1;
    },
    showSnackbar(text, color) {
      this.keyImportHolidays++;
      this.$emit("showSnackbar", text, color);
    },

    validation(form) {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.handleSubmit(form);
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },

    nextStep() {
      this.saveTemporaryData();
      this.step++;
    },
    prevStep() {
      this.step--;
    },
    saveTemporaryData() {
      for (let input of this.inputsForm) {
        this.tempData[input.name] = input.data;
      }
    },
    getTemporaryData() {
      return { ...this.tempData };
    },
    handleChange(i) {
      console.log(i);
    },
    getSelectLabel(select) {
      const maxToShow = 3; // Número máximo de elementos a mostrar
      const selectedItems = select.data.map((value) =>
        select.items.find((item) => item[select.itemsValue] === value)
      );
      const hiddenItems = Math.max(0, selectedItems.length - maxToShow);

      if (hiddenItems > 0) {
        const hiddenIndices = selectedItems
          .slice(maxToShow)
          .map((item) => select.items.indexOf(item) + 1);
        return `${selectedItems
          .slice(0, maxToShow)
          .map((item) => item[select.itemsText])
          .join(", ")} + ${hiddenItems} more (Indices: ${hiddenIndices.join(
          ", "
        )})`;
      } else {
        return selectedItems.map((item) => item[select.itemsText]).join(", ");
      }
    },
    getCurrentYear() {
      const date = new Date();
      this.currentYear = date.getFullYear();
    },
  },
};
</script>

<style scoped>
.form-container {
  display: flex;
  flex-direction: column;
}

.small {
  font-size: medium;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-previous {
  background-color: #737373 !important;
  color: white !important;
}
.bt-next {
  background-color: #39537a !important;
  color: white !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.scrollable-list {
  max-height: 300px;
  overflow-y: auto;
}
@media (max-width: 600px) {
  .bt-exit,
  .bt-acept {
    font-size: 12px !important;
    padding: 5px 10px !important;
    display: block;
  }
}
</style>
